<div class="fc-search-many-input" [ngClass]="styleToDisplay" matAutocompleteOrigin #origin="matAutocompleteOrigin">
  <div class="fc-search-many-input__prefix" (click)="displayTextInput.focus()" *ngIf="showSearchIcon">
    <mat-icon>search</mat-icon>
  </div>
  <div
    class="fc-search-many-input__infix"
    [ngClass]="{
      'has-search-icon': showSearchIcon,
      'fc-search-many-input__infix--filled': control.value
    }"
  >
    <label *ngIf="styleToDisplay !== 'outlined-style'" class="fc-search-many-input__infix-label">
      {{ label }}<span *ngIf="requiredMark">*</span>
    </label>

    <input
      #displayTextInput
      class="fc-search-many-input__infix-input"
      [ngClass]="{
        'fc-search-many-input__infix-input--filled': control.value,
        'fc-search-many-input__infix-input--disabled': disabled
      }"
      (blur)="onBlur()"
      [matAutocomplete]="matAutocomplete"
      [matAutocompleteConnectedTo]="origin"
      [matTooltip]="displayText"
      [matTooltipPosition]="tooltipPosition"
      [value]="displayText"
      [disabled]="disabled || matAutocomplete.isOpen"
      [placeholder]="styleToDisplay === 'outlined-style' ? label : ''"
    />
    <p class="fc-search-many-input__infix-paragraph">
      {{ displayText }}
    </p>
  </div>
  <div class="fc-search-many-input__suffix" (click)="openPanel($event)">
    <mat-icon class="fc-search-many-input__suffix-drop-down"> arrow_drop_down </mat-icon>
  </div>
</div>

<mat-autocomplete
  #matAutocomplete="matAutocomplete"
  [displayWith]="displayWith"
  (closed)="onCloseAutocomplete()"
  (opened)="inputFilter.focus(); onAutocompleteScroll()"
  class="fc-search-many-input__autocomplete"
>
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  <mat-option class="select-many-input-filter-option">
    <div class="select-many-input-filter" (click)="onClickInputFilter($event)">
      <mat-icon>search</mat-icon>
      <input
        #inputFilter
        [formControl]="searchTerm"
        [placeholder]="'SEARCH_MANY_INPUT.SEARCH_PLACEHOLDER' | translate"
        (keydown.space)="$event.stopPropagation()"
      />
      <img src="assets/images/icons/cancel.svg" (click)="clearSelection()" />
    </div>
  </mat-option>

  <mat-option class="fc-search-many-input__autocomplete__option" *ngFor="let option of options" [value]="option">
    <mat-checkbox
      [checked]="isSelected(option)"
      (click)="onCheck($event, option)"
      (keydown.enter)="$event.stopPropagation()"
    >
      <span
        matTooltip="{{ option | map: displayWith }}"
        [matTooltipPosition]="tooltipPosition"
        [ngClass]="{ 'fc-search-many-input__archived-type': option.archived }"
      >
        {{ option | map: displayWith }}
      </span>
      <span *ngIf="option.archived" class="fc-search-many-input__archived-label">
        {{ 'SEARCH_MANY_INPUT.ARCHIVED_OPTION' | translate }}
      </span>
    </mat-checkbox>
  </mat-option>

  <mat-option class="no-result" *ngIf="!options.length && searchTerm.value">
    {{ 'SEARCH_MANY_INPUT.NO_RESULTS' | translate }}
  </mat-option>
</mat-autocomplete>
